import { createSystem, defaultConfig } from '@chakra-ui/react'

import { accordionSlotRecipe } from './recipes/accordion'
import { alertSlotRecipe } from './recipes/alert'
import { buttonRecipe } from './recipes/button'
import { skeletonRecipe } from './recipes/skeleton'
import { spinnerRecipe } from './recipes/spinner'
import { textStyles } from './textStyles'

const breakpoints = {
  xs: { value: '0' },
  sm: { value: '329px' },
  md: { value: '768px' },
  lg: { value: '960px' },
  xl: { value: '1200px' },
  '2xl': { value: '1536px' },
}

export const theme = createSystem(defaultConfig, {
  globalCss: {
    'html, body': {
      userSelect: 'none',
    },
    '*': {
      WebkitTapHighlightColor: 'transparent',
    },
  },

  theme: {
    tokens: {
      breakpoints,

      fonts: {
        heading: {
          value: "'X5 Sans', sans-serif",
        },
        body: {
          value: "'X5 Sans', sans-serif",
        },
      },
    },
    textStyles: textStyles as any,
    recipes: {
      button: buttonRecipe,
      skeleton: skeletonRecipe,
      spinner: spinnerRecipe,
    },
    slotRecipes: {
      alert: alertSlotRecipe,
      accordion: accordionSlotRecipe,
    },
  },
})
